export default function AboutUs() {
  return (
    <div className="container py-5">
      <h1 className="fw-bold">About Us</h1>
      <p className="mt-3">
        We build scalable SaaS platforms with modern technologies.
      </p>
    </div>
  );
}
